export default __webpack_public_path__ + "static/media/Comp 2_00044.3b4d0616.png";